<template>
    <div>

		<div id="media-kit-page">
			<div class="container-fluid section-middle staticPage no-padding staticmedia">
				<div class="row row-about">
                    <h2 class="h2-produce">Media Kit</h2>
					<div class="col m12 s12 xs12" style="text-align:left">
						<p>Thanks for your interest in the Seasonal Food Guide!</p>
						<p>We’ve prepared this Media Kit to provide you with assets to use when covering the Seasonal Food Guide. Please find these resources below.</p>
						<p>If you have any questions about the Seasonal Food Guide or need another version of the images below, please email <a href="mailto:jerusha@gracelinks.org?subject=Seasonal%20Food%20Guide">jerusha@gracelinks.org.</a></p>


                        <div id="media-assets">
                            <h3 class="h3-static">SFG Media Assets</h3>
                            <ul>
                                <li><p><a target="_blank" href="/sfg-one-pager.pdf">One Pager</a> [PDF]</p></li>
                            </ul>
                            <h3 class="h3-static">Seasonal Food Guide Logo, Icon and Cover Images</h3>
                            <ul>
                                <li><p><a :href="item1.loc">Logo in charcoal with a transparent background</a> [PNG]</p></li>
                                <li><p><a :href="item2.loc">Logo in white with a transparent background</a> [PNG]</p></li>
                                <li><p><a :href="item3.loc">App Icon logo</a> [PNG]</p></li>
                                <li><p><a :href="item4.loc">Promotional cover image for article headers, etc.</a> [PNG]</p></li>
                            </ul>
                        </div>

					</div>
				</div>
			</div>
		</div>



    </div>
</template>
<script>

export default {
    data() {
        return {
            // item0: {loc: require('../assets/files/sfg-one-pager.pdf')},
            item1: {loc: require('../assets/img/other/logo-sfg-b-600.png')},
            item2: {loc: require('../assets/img/other/logo-sfg-w-600.png')},
            item3: {loc: require('../assets/img/icons/android/sfg_192x192.png')},
            item4: {loc: require('../assets/img/other/promo-header-image.png')},
        }
    }
}
</script>
<style scoped>
ul:not(.browser-default) li {
    list-style-type:disc;
}
ul:not(.browser-default) {
    padding-left: 40px
}
</style>